<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Booking Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Booking Details",
            items: [
               {
                  text: "Bookings",
                  href: "/bookings",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            booking: {},
            token: "",
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchBooking();         
      },

      methods: {
         getToken() {
            if (localStorage.getItem('sigomind_admin')) {
               var sigomind_admin =  JSON.parse(localStorage.getItem('sigomind_admin'));
               if(sigomind_admin.token) {
                  this.token = sigomind_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchBooking() {
            let url = "admin/bookings/details?booking_id=" + this.$route.params.id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  console.log(res);
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.booking = responseData.booking;

               })
               .catch((err) => console.log(err));
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'bookings' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <h4 class="card-title mb-3 color-box bg-secondary bg-soft p-3">Booking Details</h4>
                        <div class="table-responsive">
                           <table class="table mb-0">
                              
                              <tbody>
                                 <tr>
                                    <th>Booking No </th>
                                    <th>:</th>
                                    <td>BN-{{booking.id}}</td>
                                 </tr>
                                 
                                 <tr>
                                    <th>User</th>
                                    <th>:</th>
                                    <td>{{booking.patient.name}}</td>
                                 </tr>

                                 <tr>
                                    <th>Booking For</th>
                                    <th>:</th>
                                    <td>
                                       <span>{{booking.converted_booking_for}}</span>
                                    </td>
                                 </tr>

                                 <tr>
                                    <th>Consultation Preference</th>
                                    <th>:</th>
                                    <td>{{booking.converted_consultation_preference}}</td>
                                 </tr>

                                 <tr>
                                    <th>Date and Time</th>
                                    <th>:</th>
                                    <td>{{booking.converted_booking_datetime}}</td>
                                 </tr>

                                 <tr>
                                    <th>Doctor</th>
                                    <th>:</th>
                                    <td>{{booking.doctor.doctor_name}}</td>
                                 </tr>

                                 <tr>
                                    <th>Clinic</th>
                                    <th>:</th>
                                    <td>{{booking.clinic.clinic_name}}, {{booking.clinic.clinic_location}}</td>
                                 </tr>

                                 <tr>
                                    <th>Booking Status</th>
                                    <th>:</th>
                                    <td class="text-primary">{{booking.converted_status}}</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                     <div class=" col-md-6 col-lg-6">
                        <h4 class="card-title mb-3 color-box bg-secondary bg-soft p-3">Patient Details</h4>
                        <div class="table-responsive">
                           <table class="table mb-0">
                              <tbody>
                                 <tr>
                                    <th>Patient Name  </th>
                                    <th>:</th>
                                    <td>{{booking.patient.name}}</td>
                                 </tr>

                                 <tr>
                                    <th>Mobile </th>
                                    <th>:</th>
                                    <td>{{booking.patient.converted_mobile}}</td>
                                 </tr>

                                 <tr>
                                    <th>DOB </th>
                                    <th>:</th>
                                    <td>{{booking.patient.converted_dob}}</td>
                                 </tr>

                                 <tr>
                                    <th>Gender </th>
                                    <th>:</th>
                                    <td>{{booking.patient.converted_gender}}</td>
                                 </tr>

                                 <tr>
                                    <th>Place </th>
                                    <th>:</th>
                                    <td>{{booking.patient.place}}</td>
                                 </tr>
                                 
                              </tbody>
                           </table>
                        </div>


                        <h4 class="card-title mt-4 mb-3 color-box bg-secondary bg-soft p-3">Doctor Details</h4>
                        <div class="table-responsive">
                           <table class="table mb-0">
                              <tbody>
                                 <tr>
                                    <th>Doctor Name  </th>
                                    <th>:</th>
                                    <td>{{booking.doctor.doctor_name}} {{booking.doctor.qualification}}</td>
                                 </tr>

                                 <tr>
                                    <th>Specializations </th>
                                    <th>:</th>
                                    <td>
                                       <p v-for="specialization in booking.doctor.specializations" :key="specialization.id">{{specialization.specialization}}</p>
                                    </td>
                                 </tr>

                                 <tr>
                                    <th>Mobile </th>
                                    <th>:</th>
                                    <td>{{booking.doctor.converted_mobile}}</td>
                                 </tr>

                                 <tr>
                                    <th>DOB </th>
                                    <th>:</th>
                                    <td>{{booking.doctor.converted_dob}}</td>
                                 </tr>

                                 <tr>
                                    <th>Gender </th>
                                    <th>:</th>
                                    <td>{{booking.doctor.converted_gender}}</td>
                                 </tr>

                                 
                                 <tr>
                                    <th>Clinic </th>
                                    <th>:</th>
                                    <td><p v-for="clinic in booking.doctor.clinics" :key="clinic.id">{{clinic.clinic_name}}, {{clinic.clinic_location}}</p></td>
                                 </tr>

                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
